import * as applications from "./applications";
import * as candidates from "./candidate";
import * as customers from "./customers";
import * as projects from "./projects";
import * as guides from "./guides";
import * as vacancyApplications from "./vacancyApplications";
import * as vacancy from "./vacancy";
import * as analise from "./analytics";
import * as departments from "./departments";
import * as recruiters from "./recruiters";
import * as user from "./user";
import * as channel from "./channel";
import * as notifications from "./notifications";
import * as leads from "./leads";
const api = {
  applications,
  candidates,
  customers,
  projects,
  guides,
  vacancyApplications,
  vacancy,
  analise,
  departments,
  recruiters,
  user,
  channel,
  notifications,
  leads,
};

export default api;
